module.exports = __webpack_public_path__ + "img/beer_id-1.b90b7bf0.jpg";